import { INSTANCE, INSTANCELIST } from './API.js'

export const getFixSku = ({ queryKey }) =>
  new Promise((resolve, reject) => {
    const { sort, range, filter, tabFilter } = queryKey[1]

    INSTANCELIST({
      method: 'get',
      url: '/fixed-sku',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      params: {
        sort: JSON.stringify(sort),
        range: JSON.stringify(range),
        filter: JSON.stringify(filter),
        ...tabFilter,
      },
    })
      .then(resolve)
      .catch(reject)
  })

export const getFixSkuById = ({ queryKey }) =>
  new Promise((resolve, reject) => {
    const { id } = queryKey[1]

    INSTANCE({
      method: 'get',
      url: `/fixed-sku/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then(resolve)
      .catch(reject)
  })

export const createFixSku = (form) => {
  new Promise((resolve, reject) => {
    INSTANCELIST({
      method: 'post',
      url: '/fixed-sku',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      data: form,
    })
      .then(resolve)
      .catch(reject)
  })
}

export const updateFixSku = (form, id) =>
  new Promise((resolve, reject) => {
    INSTANCE({
      method: 'put',
      url: `/fixed-sku/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      data: form,
    })
      .then(resolve)
      .catch(reject)
  })

/** Public endpoint - no auth. Used for public fixed-sku view. */
export const getFixSkuByScan = (id) =>
  new Promise((resolve, reject) => {
    INSTANCE({
      method: 'get',
      url: `/fixed-sku/scan/${id}`,
    })
      .then(resolve)
      .catch(reject)
  })

/** Returns QR code data (uri) for the given fixed-sku. */
export const getQrCodeByFixSku = (fixSkuId) =>
  new Promise((resolve, reject) => {
    INSTANCE({
      method: 'get',
      url: `/qr-codes/by-fixed-sku/${fixSkuId}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then(resolve)
      .catch(reject)
  })